
import React from 'react';
import ToolCard from '@/components/ToolCard';
import NoResults from '@/components/platform/NoResults';
import type { Tool } from '@/data/tools';

interface PlatformToolsListProps {
  platform: string;
  tools: Tool[];
}

const PlatformToolsList: React.FC<PlatformToolsListProps> = ({ platform, tools }) => {
  return (
    <>
      {tools.length > 0 ? (
        <>
          <div className="mb-6 border-b pb-2">
            <h2 className="text-2xl font-semibold">All {platform} Tools</h2>
          </div>
          <div className="grid gap-4">
            {tools.map(tool => (
              <ToolCard key={tool.id} tool={tool} />
            ))}
          </div>
        </>
      ) : (
        <NoResults platform={platform} />
      )}
    </>
  );
};

export default PlatformToolsList;
